import { SVG } from '../svg';
import { IconProps } from '../types';

export function XIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </SVG>
  );
}
